import { getParent } from 'mobx-state-tree';
import { isFirstShowDateValidForConnectivityPopup } from '../../../utils/connectivityTest';
import { BILLING_CATEGORIES } from '../Billing/constants';
import { USER_ROLE_IDS } from '../constants';
import FEATURES from '../features';
const ACCOUNT_SUSPENDED = 'suspended';
const ACCOUNT_FROZEN = 'freezed'; // typo that returns on the account object from users/me
export const INDUSTRY_TO_DEMO_PROFILE = {
    marketing: '/in/yonitserruya',
    sales: '/in/yonitserruya',
    recruiting: '/in/rachel-shani-stopper-08636415',
    development: '/in/lior-halifa',
    other: '/in/yonitserruya',
};
const Views = self => ({
    get fullName() {
        return `${self.firstName} ${self.lastName}`;
    },
    get parent() {
        return getParent(self);
    },
    get isManagerSeat() {
        return self.roleId === USER_ROLE_IDS.MANAGER;
    },
    get isLushaEmployee() {
        var _a;
        return (_a = self.email) === null || _a === void 0 ? void 0 : _a.includes('lusha.co');
    },
    get isBillingIssue() {
        return self.isAccountSuspended && (self.accountStatusReason === 'payment' || self.accountStatusReason === 'dispute');
    },
    get isLimitExceeded() {
        return self.isAccountSuspended && self.accountStatusReason === 'limitExceeded';
    },
    get hasAccessToIntentFeature() {
        var _a, _b;
        const featuresToTopicLimitMap = ['intentData25Topics', 'intentData12Topics', 'intentData5Topics'];
        const isEnterpriseUser = ((_a = self.billing) === null || _a === void 0 ? void 0 : _a.category) === 'enterprise';
        return isEnterpriseUser && ((_b = self.features) === null || _b === void 0 ? void 0 : _b.some(featureCode => featuresToTopicLimitMap.includes(featureCode)));
    },
    hasAccessToFeature(feature) {
        return self.features.includes('all') || self.features.includes(feature);
    },
    get hasIntegrationPermissions() {
        return (self.features.includes(FEATURES.ALL) ||
            self.features.includes(FEATURES.SAVE_TO_CRM) ||
            self.features.includes(FEATURES.SAVE_TO_SALESFORCE) ||
            self.features.includes(FEATURES.SAVE_TO_HUBSPOT) ||
            self.features.includes(FEATURES.SAVE_TO_OUTREACH) ||
            self.features.includes(FEATURES.SAVE_TO_PIPEDRIVE) ||
            self.features.includes(FEATURES.SAVE_TO_ZOHO) ||
            self.features.includes(FEATURES.SAVE_TO_SALESLOFT));
    },
    get isAccountSuspended() {
        return (self === null || self === void 0 ? void 0 : self.accountStatus) === ACCOUNT_SUSPENDED;
    },
    get isAccountFrozen() {
        return self.subscriptionStatus === ACCOUNT_FROZEN;
    },
    get isEmpty() {
        return !self.id;
    },
    get isFree() {
        var _a;
        return ((_a = self === null || self === void 0 ? void 0 : self.billing) === null || _a === void 0 ? void 0 : _a.category) === BILLING_CATEGORIES.FREE;
    },
    get demoProfile() {
        const profile = INDUSTRY_TO_DEMO_PROFILE[self.industry];
        if (!profile) {
            return 'https://www.linkedin.com/in/assaf-eisenstein-a7b187159';
        }
        return `https://www.linkedin.com${profile}`;
    },
    get isUserRegistrationDateValidForOnDemandTest() {
        var _a;
        const currentYear = new Date().getFullYear();
        const freeUsersInsertToTestDate = new Date(currentYear, 4, 1); // mark as may first VALIDATE WITH RAN
        const FREE_USER_INSERT_TO_TEST_DATE = freeUsersInsertToTestDate.getTime();
        const USER_REGISTRATION_DATE = (_a = self === null || self === void 0 ? void 0 : self.analytics) === null || _a === void 0 ? void 0 : _a.registerDate;
        return USER_REGISTRATION_DATE >= FREE_USER_INSERT_TO_TEST_DATE;
    },
    get billingCategory() {
        var _a;
        return (_a = self === null || self === void 0 ? void 0 : self.billing) === null || _a === void 0 ? void 0 : _a.category;
    },
    get isEnterpriseAccount() {
        return self.billing === BILLING_CATEGORIES.ENTERPRISE;
    },
    get isAutomationUser() {
        const userEmail = self.email || '';
        const isLushaUser = self.isLushaEmployee;
        const hasAutoPrefix = userEmail.includes('auto');
        return hasAutoPrefix && isLushaUser;
    },
    get hasActiveIntegration() {
        var _a;
        return ((_a = self.activeIntegrations) === null || _a === void 0 ? void 0 : _a.length) > 0;
    },
    get isUserRole() {
        return self.roleId === USER_ROLE_IDS.USER;
    },
    get shouldEnterConnectivityAbTest() {
        var _a;
        const { billingCategory } = self;
        switch (billingCategory) {
            case BILLING_CATEGORIES.FREE:
                return isFirstShowDateValidForConnectivityPopup((_a = self.analytics) === null || _a === void 0 ? void 0 : _a.firstShowDate);
            case BILLING_CATEGORIES.PREMIUM:
            case BILLING_CATEGORIES.PROFESSIONAL:
                return true;
            default:
                return false;
        }
    },
    get isRenewsBillingPlan() {
        const { renews } = self.billing || {};
        return renews;
    },
    get isUserInFreeDecisionPopup() {
        var _a, _b;
        return (self.isFree &&
            !self.isRenewsBillingPlan &&
            !((_a = self.freeTrial) === null || _a === void 0 ? void 0 : _a.isActivatedFromBackoffice) &&
            ((_b = envConfig.FEATURES) === null || _b === void 0 ? void 0 : _b.FREE_TRIAL_POPUP));
    },
    get shouldRecordFullStoryAfterShow() {
        return ['US', 'AU'].includes(self.countryCode);
    },
});
export default Views;
